import React from 'react'
import "./HomeLearningCard.css"
import Widget from '../widget/Widget'

export const HomeLearningCard = ({data}) => {
  return (
    <div className="homelearningcard-container flex gap-x-5">
        <Widget
            title="School Dist"
            number={data.school_cnt}
            icon=""
        />
        <Widget
            title="Student"
            number={data.student_cnt}
        />
        <Widget
            title="Logged In Student"
            number={data.logged_in_student_cnt}
        />
        <Widget 
            title="View Time (in minutes)"
            number={data.video_usage_cnt}
        />
        <Widget 
            title="Exercise Usage (in minutes)"
            number={data.excs_usage_cnt}
        />
    </div>
  )
}
